import { Card, Heading } from "@digdir/designsystemet-react";
import { ArrowLeftIcon } from "@navikt/aksel-icons";
import "./NavItem.css";

export const NavItemBackButton: React.FC<{
    heading: string;
    onClick?: () => void;
}> = ({ heading, onClick }) => {
    return (
        <Card
            className="nav-item nav-item--top"
            data-variant="tinted"
            onClick={onClick}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    onClick?.();
                }
            }}
            role={onClick ? "button" : undefined}
            style={{ justifyContent: "flex-start" }}
            tabIndex={onClick ? 0 : -1}
            title={onClick ? "Gå tilbake til forrige nivå" : undefined}
        >
            {onClick && (
                <div className="nav-item__button">
                    <ArrowLeftIcon
                        aria-hidden="true"
                        style={{ color: "var(--ds-color-neutral-base-contrast-default)" }}
                        fontSize="var(--ds-font-size-6)"
                    />
                </div>
            )}

            <div style={{ margin: 0 }}>
                <Heading level={4} data-size="xs">
                    {heading}
                </Heading>
            </div>
        </Card>
    );
};
